import Container from '@/views/container'
export default [
  {
    path: `/`,
    component: () => import('@/views/login'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: "/goods",
    component: Container,
    meta: {
      title: "商品",
      icon: "el-icon-goods",
      index: "10"
    },
    children: [
      {
        path: "",
        component: () => import('@/views/goods')
      }
    ]
  },
	{
		path: "/ticket",
		component: Container,
		meta: {
			title: "门票",
			icon: "el-icon-tickets",
			index: "11"
		},
		children: [
			{
				path: "",
				component: () => import('@/views/ticket')
			}
		]
	},
	{
		path: "/order",
		component: Container,
		meta: {
			title: "订单",
			icon: "el-icon-wallet",
			index: "12"
		},
		children: [
			{
				path: "",
				component: () => import('@/views/order')
			}
		]
	},
	{
		path: '/wx',
		component: Container,
		meta: {
			title: "微信",
			icon: "el-icon-chat-dot-round",
			index: "13"
		},
		children: [
			{
				path: "",
				component: () => import('@/views/wx')
			}
		]
	}
]